<template>
    <transition name="modal-fade">
            <div  v-if="show" class="calendar-modal" :id="id" @pointerdown.self="close" @keyup.esc="close" ref="modal" :style="{ top:top + 'px', left:left + 'px'}">
                <div class="modal-content">
                    <div class="modal-header pb-0">
                        <slot name="header">
                            <div>
                                <h5 class="modal-title" v-html="title"></h5>
                                <label v-if="range" v-html="range"></label>
                            </div>
                        </slot>

                        <button type="button" class="close" @click="close" aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="modal-body mb-2">
                        <slot></slot>
                    </div>
                </div>
            </div>
    </transition>
</template>

<script>
export default {
    name: "Modal",
    props: {
        title: {
            type: String,
            default: 'Title',
        },
        range: {
            type: String,
            required: false,
        },
        show: {
            type: Boolean,
            default: false,
        },
        left: {
            type: Number,
            required: true,
        },
        top: {
            type: Number,
            required: true,
        },
        id: {
            type: String,
            required: true,
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
    },
    watch: {
        show(newValue, oldValue) {
            if (newValue) {
                this.$nextTick(() => {
                    this.$refs.modal.focus();
                });
            }
        }
    },
};
</script>

<style scoped>
.calendar-modal {
    display: block;
    position: absolute;
    z-index: 1000;
    background-color: white;
    border: 1px solid #ddd;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 0 20px 0px 20px;
    width: 360px;
}
.close svg {
    width: 16px;
}
.modal-content {
    border: solid 0px transparent;
}
.modal-header {
    border-bottom: solid 0px transparent;
}
.modal-fade-enter, .modal-fade-leave-to {
    opacity: 0;
}
.modal-fade-enter-active {
    transition: opacity 0.15s ease-out;
}
.modal-fade-leave-active {
    transition: opacity 0.15s ease-out;
}
</style>
